module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master-legals column"
  }, [(!_vm.isUser) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_c('logo')], 1) : _c('div', {
    staticClass: "ctn-header"
  }, [_c('my-header', {
    attrs: {
      "menu": _vm.menu,
      "notif": false,
      "help": true
    },
    on: {
      "notif-open": function($event) {
        _vm.notifPanelActive = true
      }
    }
  })], 1), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.isUser) ? _c('my-footer') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cc3b5cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/Legal/index.vue
// module id = 1106
// module chunks = 0